export default __webpack_public_path__ + "static/media/delachef-logo.2392e2d7.svg";